import axios from 'axios'
import { onSuccess, onError, beforeRequestError, signbeforeRequestSuccess } from '@/api/interceptors'
import { API_DEFAULT_TIMEOUT_MS } from '@/utils/constants'

const client = axios.create({ // creating second client to be able to use different interceptors and loading screen
  baseURL: process.env.GQL_API,
  pathToBeSetAsUrl: '/graphql/',
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

client.interceptors.request.use(signbeforeRequestSuccess, beforeRequestError)
client.interceptors.response.use(onSuccess, onError)

export let gqlClient = client



// WEBPACK FOOTER //
// ./src/api/gql/client.js